import { render, staticRenderFns } from "./StockList.vue?vue&type=template&id=e9de472e&scoped=true"
import script from "./StockList.vue?vue&type=script&lang=js"
export * from "./StockList.vue?vue&type=script&lang=js"
import style0 from "./StockList.vue?vue&type=style&index=0&id=e9de472e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9de472e",
  null
  
)

export default component.exports